import {
  Input,
  Button,
  Error,
  Info,
  FormControlWrapper
} from '../uiLib'
import { defaultValidators } from '../../lib/validation'


export const Forgot = props => {
  return (
    <div className="login-page">
      <p>{props.t('common:forgot-page-description')}</p>
      <div className="columns">
        <div className="column is-6">
          <form
            id="forgot-password-form"
            onSubmit={props.handleSubmit(props._handleSubmit)}
            noValidate
            className="m-b-md m-t-md"
          >
            <Input
              name="username"
              id="username"
              label={props.t('common:username')}
              required
              icon="email"
              horizontal
              formComponent
              placeholder={props.t('common:username')}
              validate={[
                defaultValidators.required,
                defaultValidators.email
              ]}
            />
            { props.error &&
              <Error message={props.t(props.error)} />
            }

            {
              props.submitResultInfo &&
              <Info message={props.t(props.submitResultInfo)} />
            }
            <FormControlWrapper
              horizontal
              labelOffset
            >
              <Button
                disabled={props.submitting}
                loading={props.loading}
                outlined
                btType="primary"
              >
                {props.t('common:submit')}
              </Button>
            </FormControlWrapper>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Forgot



// WEBPACK FOOTER //
// ./components/Forgot/index.js